import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { signupApi, sendOtpApi, loginApi } from "./authApi";

export const signupUser = createAsyncThunk(
  "auth/signupUser",
  async (userData, thunkAPI) => {
    try {
      const response = await signupApi(userData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const sendOtpUser = createAsyncThunk(
  "auth/sendOtpUser",
  async (emailData, thunkAPI) => {
    try {
      const response = await sendOtpApi(emailData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (loginData, thunkAPI) => {
    try {
      const response = await loginApi(loginData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const authSlice = createSlice({
  name: "auth",

  initialState: {
    loading: false,
    user: null,
    otpReference: null,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {

    builder
      .addCase(signupUser.pending, (state) => {
        state.loading = true;
      })

      .addCase(signupUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })

      .addCase(signupUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(sendOtpUser.pending, (state) => {
        state.loading = true;
      })

      .addCase(sendOtpUser.fulfilled, (state, action) => {
        state.loading = false;
        state.otpReference = action.payload.data;
      })

      .addCase(sendOtpUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
      })

      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })

      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  },
});

export default authSlice.reducer;